import { Component, OnInit, Input  } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {
    public arrData = new Array<any>();
    public arrTable = new Array<any>();
    public arrTable1 = new Array<any>();
    public arrTable2 = new Array<any>();
    @Input() webpagedefinitionitemid: number;
    @Input() docid: number;
    @Input() webpagelayoutitemid: number;
    @Input() webpagethemeelementid: number;
    @Input() cache: boolean;

    constructor(public dataservice: DataService) { }

    ngOnInit() {
        this.dataservice.getElementData(this.webpagedefinitionitemid, this.docid, this.webpagelayoutitemid, this.webpagethemeelementid, this.cache, 'g2/navigation', (returndata: any) => {
            this.arrData = returndata;
            this.arrTable = returndata.Table;
            this.arrTable1 = returndata.Table1;
            this.arrTable2 = returndata.Table2;
        }, '');

    } 

}

